import React, { Component } from 'react';

class Question extends Component {
  constructor(props) {
    super(props);

    this.state = {
      num: this.props.num,
      height: 'auto',
      show: true,
    };

    this.action = this.action.bind(this);
  }

  action() {
    this.setState({ show: !this.state.show });
  }

  componentDidMount() {
    var that = this;

    if (process.browser) {
      if (document.readyState === 'complete') {
        const height = that.divElement.clientHeight;

        that.setState({ height: height, show: false });
      } else {
        window.addEventListener('load', function () {
          const height = that.divElement.clientHeight;

          that.setState({ height: height, show: false });
        });
      }
    }
  }

  render() {
    return (
      <div
        className={
          ' px-20 mb-15 border border-gray-slider ' +
          (this.state.show ? 'show' : 'hide') +
          (this.props.from == 'ppc' ? ' bg-white' : ' bg-gray-light')
        }
      >
        <p
          className="relative text-purple text-16 md:h-75 my-1 font-medium cursor-pointer flex items-center flex-row-reverse md:flex-row"
          onClick={this.action}
        >
          <span className="faq-arrow md:-ml-5 md:mr-5"></span> <span className="w-full pr-10">{this.props.question}</span>
        </p>

        <div
          className="relative faq-content mb-15 md:px-20 transition-all overflow-hidden duration-300 ease-in-out"
          ref={divElement => {
            this.divElement = divElement;
          }}
          style={{ height: this.state.height }}
        >
          <p className="text-left text-16">{this.props.answer}</p>
          <style global jsx>{`
            .hide .faq-content {
              height: 0 !important;
              padding: 0 20px 0 20px !important;
              margin-top: 0 !important;
              margin-bottom: 0 !important;
            }
            @media screen and (max-width: 768px) {
              .hide .faq-content {
                padding: 0 !important;
              }
            }
          `}</style>
        </div>
      </div>
    );
  }
}

function Faq(props) {
  return (
    <div>
      {props.content.map(function (benefit, i) {
        return <Question key={i} num={i + 1} question={benefit.title} answer={benefit.answer}></Question>;
      })}
    </div>
  );
}

export default Faq;
